type LoaderListener = (isVisible: boolean) => void;

const listeners = new Set<LoaderListener>();
let activeMutations = 0;

function emit() {
  const isVisible = activeMutations > 0;
  listeners.forEach((listener) => listener(isVisible));
}

export function beginMutationLoading() {
  activeMutations += 1;
  emit();
}

export function endMutationLoading() {
  activeMutations = Math.max(0, activeMutations - 1);
  emit();
}

export function subscribeMutationLoading(listener: LoaderListener) {
  listeners.add(listener);
  listener(activeMutations > 0);
  return () => {
    listeners.delete(listener);
  };
}

export function shouldTrackMutationRequest(method?: string, url?: string) {
  const requestMethod = (method || "get").toLowerCase();
  const requestUrl = (url || "").toLowerCase();

  if (!["post", "put", "patch", "delete"].includes(requestMethod)) {
    return false;
  }

  if (["put", "patch", "delete"].includes(requestMethod)) {
    return true;
  }

  if (requestUrl.includes("/get/")) {
    return false;
  }

  const mutationHints = [
    "/create/",
    "/update/",
    "/delete/",
    "/invite/",
    "/uploaddoc",
    "/checkout/",
    "/register/update",
  ];

  return mutationHints.some((hint) => requestUrl.includes(hint));
}

